import { apiGetRequest, apiPostRequest } from "../utils/webrequests";
import {Question, EventQuestionnaire} from "../data/eventQuestionnaire";
import {Communication} from "../data/Communication";
import {EventResponse} from "../data/registration";

export async function getEventQuestionnaire(eventId: string): Promise<EventQuestionnaire> {
    try {
        const data: EventQuestionnaire | undefined = await apiGetRequest(`getQuestionnaire/${eventId}`, null);

        if (!data) {
            throw new Error("No questionnaire data returned from API.");
        }

        return data;
    } catch (error: any) {
        throw new Error("Error fetching event questionnaire: " + error.message);
    }
}

export async function saveQuestionnaireResponse(response: EventResponse) {
    try {
        const data: EventResponse = await apiPostRequest(
            `events/registration`,
            response
        );
        return data;
    } catch (error: any) {
        console.error("Error updating communication:", error);
        throw new Error("Error updating communication: " + error.message);
    }

}